<template>
  <div class="header" :style="topStyle">
    <div class="header-top" :style="bgStyle" ref="headerNar">
      <div class="header-logo">
        <router-link to="">
          <img
            v-if="actIndex == 0"
            src="../../static/images/home/back_logo2.png"
            alt=""
          />
          <img v-else src="../../static/images/home/back_logo.png" alt="" />
        </router-link>
      </div>
      <ul class="open-menu" @click="openMenu">
        <li></li>
        <li></li>
        <li></li>
      </ul>
      <transition name="menu">
        <div class="menu" v-show="menuSwitch">
          <div class="title">
            <img src="../../static/images/home/back_logo.png" />
            <i @click="closeMenu" class="iconfont icon-cuohao"></i>
          </div>

          <ul class="header-list">
            <li v-for="(item, index) in headerList" :key="item.id">
              <!-- <span :class="{ active: item.id == actIndex }"></span> -->
              <div class="list-line">
                <p
                  @click.stop="touchEnter(item, 'big', index)"
                  :class="{
                    y_color: item.id == actIndex,
                  }"
                >
                  {{ item.desc }}
                </p>
                <div
                  class="img-box"
                  v-if="item.dropDown && item.dropDown.length"
                  @click="switchModal(item.id, 'outside')"
                  ref="optionTitle"
                >
                  <img
                    v-if="showOpen && outsideIndex == item.id"
                    src="../../static/images/home/xiangshang.png"
                  />
                  <img v-else src="../../static/images/home/xiangxia.png" />
                </div>
              </div>
              <!-- item.id == outsideIndex -->
              <transition name="drop-down">
                <div
                  class="options"
                  v-show="showOpen && outsideIndex == item.id"
                >
                  <div v-for="(option) in item.dropDown" :key="option.id" >
                    <div class="list-line" v-if="option.title">
                      <span :class="{ active: option.id == actIndex }"></span>
                      <div
                        class="options-title"
                        @click="touchEnter(option, 'middle', index,option.idd)"
                      >
                      <p :class="{ y_color: actId == option.id }">
                        {{ option.title }}
                      </p>
                      </div>
                      <div
                        class=""
                        v-if="option.list && option.list.length"
                        @click="switchModal(option.id, 'inside')"
                      >
                        <img
                          v-if="insideIndex == option.id && showOpen"
                          src="../../static/images/home/xiangshang.png"
                        />
                        <img
                          v-else
                          src="../../static/images/home/xiangxia.png"
                        />
                      </div>
                    </div>

                    <div
                      class="options-content"
                      v-for="(d_item, d_index) in option.list"
                      :key="d_index"
                      @click="touchEnter(d_item)"
                      v-show="option.id == insideIndex"
                    >
                      {{ d_item.desc }}
                    </div>
                  </div>
                </div>
              </transition>
            </li>
          </ul>
          <div class="btn-box">
            <img src="../../static/images/home/good.png" />
            <div class="btn" @click="jumpService">立即咨询</div>
          </div>
        </div>
      </transition>
    </div>
    <div class="header-swiper-container" v-if="showSwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="image in imgList" :key="image.id">
          <img :src="image.phone_image" alt="" class="bannerImg" />
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
    <div class="big-title" v-if="titleObj.title">
      <h2>{{ titleObj.title }}</h2>
      <p>{{ titleObj.desc }}</p>
      <div v-if="titleObj.id !== 8" class="btn" @click="jumpService">立即咨询</div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "Header",
  props: {
    actIndex: Number,
    actId: String,
    imgList: {
      type: Array,
      default: [],
    },
    topStyle: String,
    bgStyle: String,
    logo: String,
    showback: Boolean,
    titleObj: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      enterIndex: -1,
      insideIndex: -1,
      outsideIndex: -1,
      showOpen: false,
      menuSwitch: false,
      phoneSwitch: false,
      optionId: '',
      headerList: [
        {
          id: 0,
          desc: "首页",
          dropDown: [],
          url: "/",
        },
        {
          id: 1,
          desc: "软件研发",
          url: "/m_custom",
        },
        {
          id: 9,
          desc: "广告投放",
          url: "/m_AdPutting",
        },
        {
          id: 2,
          desc: "FA融资",
          url: "/m_FaFinancing",
        },
        //   {
        //     id: 2,
        //     desc: "匠系产品",
        //     url: "/",
        //     dropDown: [
        //       // {
        //       //   id: 0,
        //       //   title: "智慧营销体系",
        //       //   url: "/m_craftproduct",
        //       //   list: [
        //       //     { id: 0, url: "/m_wisdomMarket/spread", desc: "智慧传播" },
        //       //     { id: 1, url: "/m_wisdomMarket/case", desc: "智慧案场" },
        //       //     { id: 2, url: "/m_wisdomMarket/channel", desc: "智慧渠道" },
        //       //   ],
        //       // },
        //       // {
        //       //   id: 1,
        //       //   title: "智慧经营体系",
        //       //   url: "/",
        //       //   list: [{ url: "", desc: "智慧售楼系统" }],
        //       // },
        //       // {
        //       //   id: 2,
        //       //   title: "智慧生活体系",
        //       //   url: "/",
        //       // },
        //       // {
        //       //   id: 3,
        //       //   title: "5G彩信营销方案",
        //       //   url: "/m_fiveG",
        //       // },
        //       // {
        //       //   id: 4,
        //       //   title: "免单节营销解决方案",
        //       //   url: "/freeMarket",
        //       // },
        //     ],
        //   },
        {
          id: 3,
          desc: "解决方案",
          url: "/m_solution/1",
        },
        {
          id: 4,
          desc: "案例中心",
          url: "/m_cases",
        },
        {
          id: 5,
          desc: "服务中心",
          url: "/m_service",
        },
        {
          id: 6,
          desc: "合作加盟",
          url: "/m_cooperation",
        },
        // {
        //   id: 7,
        //   desc: "新闻中心",
        //   dropDown: [],
        //   url: "/m_news",
        // },
        {
          id: 8,
          desc: "关于我们",
          url: "/m_about",
        },
      ],
    };
  },
  methods: {
    getHeaderList() {
      let _that = this;
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/productandsolve",
        null,
        (res) => {
          // console.log(res);
          if (res.code == 1) {
            let list = [
              { id: 0, url: "/m_wisdomMarket/spread", desc: "智慧传播" },
              { id: 1, url: "/m_wisdomMarket/case", desc: "智慧案场" },
              { id: 2, url: "/m_wisdomMarket/channel", desc: "智慧渠道" },
            ];
            let productList = res.data.productDown.rightList;
            let solveRight = res.data.solveDown.rightList;
            // this.headerList[2].dropDown = [
            //   ...productList[0].list,
            //   ...productList[1].list,
            //   ...productList[2].list,
            // ];
            // this.headerList[2].dropDown[0].list = list;
            this.headerList[3].dropDown = [
              ...solveRight[0].list,
              ...solveRight[1].list,
              ...solveRight[2].list,
              ...solveRight[3].list,
            ];

            this.getCaseList();
         
          }
        }
      );
    },
    jumpService() {
      this.$addConsult()
    },
    openMenu() {
      //打开菜单
      this.menuSwitch = true;
       document.body.style = "width: 100vw; height: 100vh; overflow: hidden;"
    },

    // 获取行业解决方案
    getCaseList(){
      this.$http.get(
        "https://eartisanapplets.wsandos.com/api/industry_case/CaseList",
        null,
        (res) => {
          let newArr = [];
          const arr = res.data.case_list;
          arr.map((item,index) => {
            if(item.status != 1) return;
            newArr.push({
              id:item.id,
              title:res.data.case_list[index].name,
              desc:res.data.case_list[index].sub_name,
              url: `/solution/proGramme?id=${item.id}`,
              idd:item.id
            })
          })
          if(newArr.length > 0){
            let arr = [];
            arr.push(...newArr,...this.headerList[3].dropDown);
            this.headerList[3].dropDown = arr;
          }
        }
      );
    },

    closeMenu() {
      //关闭菜单
      this.menuSwitch = false;
      document.body.style = "width: 100vw; height: 100vh; overflow: visible;"
      
    },
    openPhone() {
      this.phoneSwitch = true;
    },
    closePhone() {
      this.phoneSwitch = false;
    },
    switchModal(id, type) {
      if (type == "inside") {
        this.insideIndex = id;
      } else if (type == "outside") {
        this.outsideIndex = id;
      }
      this.showOpen = !this.showOpen;
    },
    touchEnter(item, type, index,idd) {
      console.log(idd);
      if(idd){
        this.pageUrl("/m_solutionProramme/" + item.idd);
        return;
      }
      // console.log(item, type, index, "1231231", this.enterIndex);
      if (item.id != this.enterIndex) {
        if (type == "big") {
          this.enterIndex = item.id;
        }
        // console.log(this.enterIndex, "this.enterIndex");
        if (!(item.dropDown && item.dropDown.length)) {
          if (index && index == 3) {
            setTimeout(() => {
                this.pageUrl("/m_solution/" + item.id, item.id);
            }, 100);
          } else {
            setTimeout(() => {
              this.pageUrl(item.url);
            }, 100);
          }
        }
      }
      // if (type == "outside" && this.outsideIndex != item.id) {
      //   this.outsideIndex = item.id;
      // } else if (type == "inside" && this.insideIndex != item.id) {
      //   this.insideIndex = item.id;
      // }
    },
    pageUrl(url) {
      setTimeout(() => {
        this.closeMenu();
      }, 200);
      // console.log(url, "12321");
      if(url === '/m_solution/17') {
        this.$router.push('/');
        this.$addConsult()
      } else if(url === '/m_solution/18'){
        this.$router.push('/');
        this.$addConsult()
      }
      else {
          this.$router.push(url);
      }
    },
    top() {
      setTimeout(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.$refs.top.style.display = "none";
      }, 20);
    },
    back() {
      this.$router.back(-1);
    },
    imgSwiper() {
      var swiper = new Swiper(".header-swiper-container", {
        autoplay: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "custom",
          renderCustom(swiper, current, total) {
            var customPaginationHtml = "";
            for (var i = 0; i < total; i++) {
              //判断哪个分页器此刻应该被激活
              if (i == current - 1) {
                customPaginationHtml +=
                  '<span class="swiper-pagination-customs swiper-pagination-customs-active"></span>';
              } else {
                customPaginationHtml +=
                  '<span class="swiper-pagination-customs"></span>';
              }
            }
            return customPaginationHtml;
          },
        },
      });
    },
    bodyScroll() {
      var num = document.body.scrollTop;
      var headerNar = this.$refs.headerNar;
      var top = this.$refs.top;
      var back = this.$refs.back;
      if (this.showback) back.style.display = "block";
      if (num > 0) {
        headerNar.className = "header-top header-top-fixed";
        if (num > 700) {
          top.style.display = "block";
        } else {
          top.style.display = "none";
        }
      } else {
        headerNar.className = "header-top";
      }
    },
  },
  created() {
    this.getHeaderList();
  },
  mounted() {
    document.addEventListener("scroll", this.bodyScroll);
  },
  destroyed() {
    document.removeEventListener("scroll", this.bodyScroll);
  },
  computed: {
    showSwiper() {
      return this.imgList.length;
    },
  },
  watch: {
    $route(to, from) {
      // console.log(to.path, "watch_path");
      // this.$router.go(0);
      window.location.reload();
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varible.styl';

.big-title {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  width: 100%;
  top: 25%;
  flex-direction: column;
  text-align: center;
  line-height: 60px;

  h2 {
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
  }

  p {
    display: inline-block;
    width: 280px;
    min-height: 60px;
    line-height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    margin-top: 8px;
    white-space: pre-line;
    opacity: 0.7;
  }

  .btn {
    z-index: 9;
    width: 103px;
    height: 36px;
    border: 1px solid #FFFFFF;
    border-radius: 20px;
    margin-top: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 32px;
    text-align: center;
    opacity: 0.7;
  }
}

.header >>> .header-swiper-container {
  position: absolute;
  width: 100%;
  top: 25%;
  overflow: hidden;
  height: 200px;

  .swiper-slide {
    height: auto;
  }

  .swiper-pagination-custom {
    bottom: 2.4%;
    left: 0;
    width: 100%;
  }

  .swiper-pagination-customs {
    display: inline-block;
    width: 0.16rem;
    height: 0.08rem;
    margin: 0 0.04rem;
    border-radius: 0.04rem;
    background: #FFFFFF;
    opacity: 0.5;
  }

  .swiper-pagination-customs-active {
    opacity: 1;
    width: 0.32rem;
    height: 0.08rem;
    background: #FFC000;
    border-radius: 0.04rem;
  }
}

.header {
  position: relative;
  // width: 100%;
  margin: 0 auto;
  padding-bottom: 90%;
  background-position: center !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;

  img {
    width: 100%;
    height: 100%;
  }

  .header-top {
    position: absolute;
    z-index: 11;
    top: 0;
    width: 100%;
    margin: 0 auto;
    background: #fff;

    .header-logo {
      float: left;
      width: 28%;
      margin-top: 10%;
      margin-left: 0.4rem;
      margin-bottom: 0.4rem;
    }

    .open-menu {
      position: absolute;
      top: 40%;
      right: 0%;
    }

    >ul:first-of-type {
      float: right;
      margin-right: 0.5rem;
      margin-top: 0.1rem;

      li {
        border-top: 0.04rem solid #ffebb0;
        height: 0.18rem;
        width: 0.5rem;
      }
    }

    .menu {
      position: fixed;
      top: 0;
      left: 0;
      background-color: #fff;
      width: 100%;
      // height: 100%;
      height:100vh;
      z-index: 99;
      padding-bottom: 8%;
      overflow-y: scroll;
		overflow-x hidden;

      .btn-box {
        position: relative;
        padding-left: 19px;
        width: 100%;

        img {
          width: 100%;
          height: 100%;
        }

        .btn {
          position: absolute;
          right: 10%;
          top: 45%;
          text-align: center;
          width: 102px;
          height: 34px;
          line-height: 34px;
          border: 1px solid #FFFFFF;
          border-radius: 2px;
          font-size: 12px;
          font-weight: 500;
          color: #FFFFFF;
        }
      }

      .title {
        position: relative;
      }

      .title::before {
        position: absolute;
        content: '';
        left: 20px;
        top: 80px;
        width: 375px;
        height: 1px;
        background: #E1E1E9;
      }

      >div {
        width: 100%;
        box-sizing: border-box;
        padding: 6.7% 5% 0 5%;

        img {
          width: 35%;
        }

        i {
          float: right;
          color: #2A3150;
          padding: 1%;
          font-size: 0.5rem;
        }
      }

      .header-list {
        width: 100%;
        margin-top: 10%;

        .list-line {
          position: relative;
          border-bottom: 1px solid #E1E1E9;

          .img-box {
            position: absolute;
            top: 0;
            text-align: center;
            line-height: 60px;
            right: -5%;
            width: 160px;
            height: 100%;
          }

          img {
            position: absolute;
            width: 12px;
            height: 7px;
            line-height: 60px;
            top: 50%;
            z-index: 5;
          }
        }

        p.y_color {
          color: $yellow;
        }

        .options {
          .options-title {
            font-size: 16px;
            font-weight: 500;
            width: 60%;
            color: #666666;
            padding: 6% 0 6% 8%;

            p {
              position: relative;
              padding: 0% 0 0% 5%;
              width: 100%;
              z-index: 6;
              line-height: 23px;
            }
            
          }

          .options-content {
            font-size: 14px;
            font-weight: 500;
            color: #999999;
            padding: 6% 0 6% 12%;
            border-bottom: 1px solid #E1E1E9;
          }
        }

        li {
          position: relative;
          box-sizing: border-box;
          color: #2A3150;
          transition: all 0.3;
          z-index: 6;
          font-size: 16px;
          font-weight: 500;
          margin: 0 5%;

          p {
            position: relative;
            padding: 6% 0 6% 5%;
            width: 60%;
            z-index: 6;
          }

          // span.active {
          // position: absolute;
          // left: -5%;
          // top: 50%;
          // margin-top: -0.5em;
          // content: '';
          // height: 1em;
          // border-right: 2px solid $yellow;
          // }
          .touch-enter, .touch-leave-to {
            width: 0;
          }

          .touch-enter-to, .touch-leave {
            width: 100%;
          }

          .touch-enter-active, .touch-leave-active {
            transition: width 0.4s;
          }
        }
      }
    }
  }

  .header-top-fixed {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 15;
  }

  .opened {
    z-index: 25;
  }

  >div.iconfont {
    position: fixed;
    right: 4%;
    bottom: 25%;
    z-index: 14;
    font-size: 0.3rem;

    i {
      display: none;
      font-size: 0.3rem;
      padding: 0.6em;
      margin-bottom: 15%;
      border-radius: 0.1rem;
    }

    .backTop {
      background: $yellow;
      color: #fff;
    }

    .back {
      background: #f5f5f5;
      color: #999;
    }

    .phone {
      display: block;
      width: 2.1em;
      padding: 0;
      // img
      // width: 100%
    }
  }

  .call-phone {
    position: fixed;
    z-index: 999;
    width: 62%;
    height: 2rem;
    right: 0;
    left: 0;
    bottom: 5rem;
    margin: 0 auto;
    padding: 0.4rem 2% 0.4rem;
    font-size: 30px;
    color: $black;
    background: #fff;
    text-align: center;

    h5 {
      font-size: 0.3rem;
      line-height: 1.6em;
      font-weight: 800;
      color: #666;
    }

    p {
      font-size: 0.4rem;
      line-height: 1.6em;
    }

    div {
      margin-top: 8%;

      span {
        display: inline-block;
        font-size: 0.3rem;
        color: #999;
        border: 1px solid #aaa;
        padding: 0.5em 2.4em;
        font-weight: 800;
      }

      a {
        display: inline-block;
        color: #fff;
        background: $yellow;
        border: 1px solid $yellow;
        font-size: 0.3rem;
        padding: 0.5em 2.4em;
        font-weight: 800;
        text-decoration: none;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/Header.vue